import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "next/router";
import MuiDialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Zoom from "@material-ui/core/Zoom";
import { ReactComponent as ModalCloseButton } from "../../assets/svg/modalclosebuttonwhite.svg";
import { ReactComponent as ModalBackButton } from "../../assets/svg/backbutton.svg";
import FacebookLogin from "react-facebook-login";
import { GoogleLogin } from "react-google-login";
import { RegistrationLoader } from "../lottie/Loader";
import {
  signUpRequest,
  signInRequest,
  recoverPasswordInitiateRequest,
  recoverPasswordVerifyOtpRequest,
  setNewPasswordRequest,
  recoverPasswordInitiateClearRequest,
  recoverPasswordVerifyOtpClearRequest,
  addEmailContactRequest
} from "../../redux/action";
import { connect } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import Alert from "../generic/Alert";
import SignOut from "./SignOut";
import SignInLottie from "../lottie/SignInLottie";
import SignUpLottie from "../lottie/SignUpLottie";
import GetUserDetails from "./GetUserDetails";
import { validateForm } from "../../services/validateForm";
const TEST_SITE_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

function Transition(props) {
  return <Zoom in={true} {...props} style={{ transformOrigin: "75% 50% 0" }} />;
}

const Dialog = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    width: "100%",
    height: "100vh",
    maxHeight: "100%",
    position: "absolute",
    zIndex: 100000,
    top: 0,
    right: 0,
    padding: 0,
    background: "rgba(0,0,0,.32)"
  },
  closeButton: {
    position: "absolute",
    right: 0,
    top: 0,
    color: theme.palette.grey[500]
  }
}))(props => {
  const { children, classes, onClose, open, TransitionComponent } = props;
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      TransitionComponent={TransitionComponent}
      classes={{ paper: classes.root }}
    >
      {children}
    </MuiDialog>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: 0,
    paddingTop: 0,
    backgroundImage: "linear-gradient(29deg, #514bed, #38e5c7)",
    textAlign: "center"
  }
}))(MuiDialogContent);

class RegistrationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      signIn: true,
      signUp: false,
      manualRegistration: true,
      login: true,
      resetPassword: false,
      sendPassword: false,
      data: { name: "", password: "", email: "" },
      loginData: { email: "", password: "" },
      resetPasswordData: { email: "" },
      newPasswordData: { password: "" },
      errors: {},
      socialError: "",
      isRecaptcha: false,
      recaptchaValue: "",
      otp: { one: "", two: "", three: "", four: "", five: "", six: "" },
      openSignOutModal: false,
      sendEmail: {
        openSendEmailModal: false,
        socialToken: "",
        signInMode: ""
      }
    };
    this._reCaptchaRef = React.createRef();
    this.one = React.createRef();
    this.two = React.createRef();
    this.three = React.createRef();
    this.four = React.createRef();
    this.five = React.createRef();
    this.six = React.createRef();
    this.emailForSigningOut = "";
  }

  /**The function to be called when the user successfully completes the captcha */
  handleChange = recaptchaValue => {
    this.setState({ recaptchaValue, isRecaptcha: false });
    // if value is null recaptcha expired
    if (recaptchaValue === null) this.setState({ expired: "true" });
  };

  /**Closes the registration modal */
  handleClose = () => {
    this.props.modalHandler();
    this.setState({
      resetPassword: false,
      signIn: true,
      signUp: false,
      manualRegistration: null,
      login: null,
      sendPassword: false
    });
  };

  /**Sending email for which password needs to be updated for generating OTP */
  sendPasswordHandler = e => {
    e.preventDefault();
    const { resetPasswordData } = this.state;
    const errors = validateForm(this.state.resetPasswordData);
    this.setState({ errors });
    const data = {
      client: "web",
      email: resetPasswordData.email
    };
    if (!Object.keys(errors).length) {
      this.props.passwordInitiateRequest(data);
    }
  };

  /**Back button on reset password screen" */
  back = () => {
    if (this.state.sendPassword) {
      this.setState({ sendPassword: false, resetPassword: true });
    } else {
      this.setState({
        resetPassword: false,
        signIn: true,
        signUp: false,
        manualRegistration: null,
        login: null,
        sendPassword: false
      });
    }
  };

  componentDidUpdate(previousProps) {
    const {
      signUpData,
      signInData,
      setNewPasswordData,
      passwordInitiateData,
      addEmailContactData
    } = this.props;

    if (
      signUpData.isError &&
      previousProps.signUpData.isError !== signUpData.isError
    ) {
      this.setState({ isRecaptcha: false, recaptchaValue: "" });
    }

    if (
      signInData.isSuccess &&
      signInData.isSuccess !== previousProps.signInData.isSuccess
    ) {
      if (
        (signInData.data.Message && signInData.data.Message === "Not Found") ||
        (signInData.data.Reason &&
          signInData.data.Reason === "Invalid Password")
      ) {
        this.setState({ isRecaptcha: false, recaptchaValue: "" });
      }
    }

    if (
      signUpData.isSuccess &&
      signUpData.isSuccess !== previousProps.signUpData.isSuccess
    ) {
      localStorage.setItem(
        "user_info",
        JSON.stringify({
          token: signUpData.data.data.token,
          userid: signUpData.data.data.userid,
          data: signUpData.data.data
        })
      );
      this.props.cookies.set('user_info',{
        token: signUpData.data.data.token,
        userid: signUpData.data.data.userid,
        data: signUpData.data.data
      })
      this.props.history.push("/learn");
    }

    if (
      signInData.isSuccess &&
      signInData.isSuccess !== previousProps.signInData.isSuccess &&
      signInData.data.Message &&
      signInData.data.Message === "SUCCESS"
    ) {
      localStorage.setItem(
        "user_info",
        JSON.stringify({
          token: signInData.data.data.token,
          userid: signInData.data.data.userid,
          data: signInData.data.data
        })
      );
      this.props.cookies.set('user_info',{
        token: signInData.data.data.token,
        userid: signInData.data.data.userid,
        data: signInData.data.data
      } )
      this.props.history.push("/learn");
    }

    if (
      passwordInitiateData.isSuccess !==
      previousProps.passwordInitiateData.isSuccess
    ) {
      if (
        passwordInitiateData.isSuccess &&
        passwordInitiateData.data &&
        passwordInitiateData.data.userid
      ) {
        this.setState({ sendPassword: true });
      }
    }
    if (
      setNewPasswordData.isSuccess !==
      previousProps.setNewPasswordData.isSuccess
    ) {
      if (
        setNewPasswordData.isSuccess &&
        setNewPasswordData.data &&
        setNewPasswordData.data.Message &&
        setNewPasswordData.data.Message === "SUCCESS"
      ) {
        this.props.recoverPasswordInitiateClearData();
        this.props.recoverPasswordVerifyOtpClearData();
        this.setState({
          sendPassword: false,
          signIn: false,
          signUp: true,
          manualRegistration: false,
          login: true,
          resetPassword: false
        });
      }
    }

    if (
      signInData.isError &&
      signInData.isError !== previousProps.signInData.isError
    ) {
      if (
        signInData.data &&
        signInData.data.status === 401 &&
        signInData.data.data.status === 0
      ) {
        // this.props.modalHandler();
        setTimeout(this.onOpenSignOutModal(), 200);
      }

      if (
        signInData.data.data.Message &&
        signInData.data.data.Message === "FAILURE" &&
        signInData.data.data.Reason &&
        signInData.data.data.Reason === "Email not available"
      ) {
        this.handleClose();
        setTimeout(this.onOpenSendEmail(), 200);
      }
    }

    //Sign in user after updating its email if not getting from social methods
    if (
      addEmailContactData.isSuccess &&
      addEmailContactData.isSuccess !==
        previousProps.addEmailContactData.isSuccess &&
      addEmailContactData.data &&
      addEmailContactData.data.Message &&
      addEmailContactData.data.Message === "SUCCESS"
    ) {
      this.closeSendEmail();
      localStorage.setItem(
        "user_info",
        JSON.stringify({
          token: addEmailContactData.data.data.token,
          userid: addEmailContactData.data.data.userid,
          data: addEmailContactData.data.data
        })
      );
      this.props.cookies.set('user_info', {
        token: addEmailContactData.data.data.token,
        userid: addEmailContactData.data.data.userid,
        data: addEmailContactData.data.data
      })
      this.props.history.push("/learn");
    }

    window.addEventListener("keydown", this.handleArrowKeys);
  }
  /**Opens Sign out Modal */
  onOpenSignOutModal = () => this.setState({ openSignOutModal: true });

  /**Closes sign out modal */
  closeSignOut = () => this.setState({ openSignOutModal: false });

  onOpenSendEmail = () =>
    this.setState({
      sendEmail: { ...this.state.sendEmail, openSendEmailModal: true }
    });

  closeSendEmail = () =>
    this.setState({
      sendEmail: { ...this.state.sendEmail, openSendEmailModal: false }
    });

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleArrowKeys);
  }

  handleArrowKeys = event => {
    const { verifyOtpData } = this.props;
    const {
      manualRegistration,
      signIn,
      signUp,
      login,
      resetPassword,
      sendPassword
    } = this.state;
    if (event.keyCode == 13) {
      if (manualRegistration && signIn) {
        this.googleRecaptcha("singIn");
      } else if (signUp && login) {
        this.googleRecaptcha("logIn");
      } else if (signIn && resetPassword && login && !sendPassword) {
        this.sendPasswordHandler(event);
      } else if (signIn && resetPassword && login && !verifyOtpData.isSuccess) {
        this.otpVerifyHandler(event);
      } else if (signIn && resetPassword && login && verifyOtpData.isSuccess) {
        this.updatePassword(event);
      }
    }
  };

  googleRecaptcha = value => {
    const { recaptchaValue } = this.state;
    if (value === "singIn") {
      const errors = validateForm(this.state.data);
      this.setState({ errors }, () => {
        if (recaptchaValue === "" && !Object.keys(errors).length) {
          this.setState({ isRecaptcha: true });
        }
        if (recaptchaValue !== "" && recaptchaValue !== null) {
          this.onSubmit();
        }
      });
    } else {
      const errors = validateForm(this.state.loginData);
      this.setState({ errors }, () => {
        if (recaptchaValue === "" && !Object.keys(errors).length) {
          this.setState({ isRecaptcha: true });
        }
        if (recaptchaValue !== "" && recaptchaValue !== null) {
          this.onLoginViaEmail();
        }
      });
    }
  };

  /**Signing Up a user through Email */
  onSubmit = () => {
    const errors = validateForm(this.state.data);
    let formData = this.state.data;
    this.setState({ errors }, async () => {
      if (!Object.keys(this.state.errors).length) {
        localStorage.setItem(
          "signin_user_info",
          JSON.stringify({
            name: formData.name,
            email: formData.email
          })
        );
        this.props.cookies.set('signin_user_info',{
          name: formData.name,
          email: formData.email
        } )
        let client = "web";
        let version = "123";
        formData = Object.assign(formData, { client, version });
        await this.props.signUp(formData);
      }
    });
  };

  /**Signing In a user through email */
  onLoginViaEmail = async () => {
    const errors = validateForm(this.state.loginData);
    let formData = this.state.loginData;
    this.setState({ errors });
    if (!Object.keys(errors).length) {
      this.email = formData.email;
      this.password = formData.password;
    
      let client = "web";
      let version = "123";
      formData = Object.assign(formData, { client, version, method: "manual" }); 
      await this.props.signIn(formData);
    }
  };

  /**Handles change of Sign In form text field */
  loginChangeHandler = event => {
    const { target } = event;
    const { name, value } = target;
    const loginData = { ...this.state.loginData };
    loginData[name] = value;
    this.setState({ loginData });
  };

  /**Toggling of SignUp and SignIn screen */
  registrationHandler = () => {
    this.setState({
      signIn: !this.state.signIn,
      signUp: !this.state.signUp,
      // manualRegistration: null,
      // login: null
    });
  };

  /**Shows SignUp or Sign In form */
  registrationMethod = () => {
    if (this.state.signIn) {
      this.setState({
        manualRegistration: true,
        login: false,
        resetPassword: false
      });
    } else if (this.state.signUp) {
      this.setState({
        manualRegistration: false,
        login: true,
        resetPassword: false
      });
    }
  };

  /**Handles change of Sign Up form text field */
  onChangeHandler = event => {
    const { target } = event;
    const { name, value } = target;
    const data = { ...this.state.data };
    data[name] = value;
    //  const errors =validateForm(this.state.data)
    this.setState({ data });
  };

  /**For Showing Reset Password screen */
  resetPasswordHandler = () => {
    this.setState({ signIn: true, signUp: false, resetPassword: true });
  };

  /**Signing In a user through facebook */
  facebookUser = async response => {
    let facebookData = {};
    if (response && response.accessToken) {
      let data = Object.assign(facebookData, {
        token: response.accessToken,
        from: "facebook",
        client: "web",
        courses: [],
        method : 'social'
      });
      this.email = response.email;
      // if (!response.email) {
        this.setState({
          sendEmail: {
            ...this.state.sendEmail,
            socialToken: response.accessToken,
            signInMode: "facebook"
          }
        });
      // }
      await this.props.signIn(data);
    } else if (
      response &&
      !response.accessToken &&
      response.status &&
      response.status !== undefined
    ) {
      this.setState({
        socialError: "Oops! Something went wrong, Please try again later"
      });
    }
  };

  /**Signing In a user through Google */
  googleUser = async response => {
    let googleData = {};
    if (
      response &&
      response.tokenId &&
      response.error !== "popup_closed_by_user"
    ) {
      this.email = response.profileObj.email;
      let data = Object.assign(googleData, {
        token: response.tokenId,
        from: "google",
        client: "web",
        courses: [],
        method : 'social'
      });
      // if (!response.profileObj.email) {
        this.setState({
          sendEmail: {
            ...this.state.sendEmail,
            socialToken: response.tokenId,
            signInMode: "google"
          }
        });
      // }
      await this.props.signIn(data);
    } else if (
      response &&
      !response.tokenId &&
      response.error !== "popup_closed_by_user"
    ) {
      this.setState({
        socialError: "Oops! Something went wrong, Please try again later"
      });
    }
  };

  /**Handles changing of email for which password needs to be updated in Reset Password*/
  resetPasswordEmailHandler = event => {
    const { target } = event;
    const { name, value } = target;
    const resetPasswordData = { ...this.state.resetPasswordData };
    resetPasswordData[name] = value;
    this.setState({ resetPasswordData });
  };

  /**Handles filling in of OTP number in Reset Password*/
  otpHandler = event => {
    const { target } = event;
    const { name, value } = target;
    const otp = { ...this.state.otp };
    otp[name] = value;
    this.setState({ otp });
    if (value.length === 1) {
      let next = this[name].current.nextSibling;
      if (next && next.tagName === "INPUT") {
        next.focus();
      }
    }
  };

  /**For verifying OTP with backend*/
  otpVerifyHandler = e => {
    e.preventDefault();
    const { passwordInitiateData } = this.props;
    const { one, two, three, four, five, six } = this.state.otp;
    const data = {
      client: "web",
      version: "123",
      userid: passwordInitiateData.data.userid,
      code: one + two + three + four + five + six
    };
    if ((one + two + three + four + five + six).length == 6) {
      this.props.verifyOtp(data);
    }
  };

  /**Handles changing of new password text in Reset Password */
  newPasswordChangedHandler = event => {
    const { target } = event;
    const { name, value } = target;
    const newPasswordData = { ...this.state.newPasswordData };
    newPasswordData[name] = value;
    this.setState({ newPasswordData });
  };

  /**For updating password */
  updatePassword = e => {
    e.preventDefault();
    const { newPasswordData } = this.state;
    const { passwordInitiateData, verifyOtpData } = this.props;
    const errors = validateForm(this.state.newPasswordData);
    this.setState({ errors });
    const data = {
      userid: passwordInitiateData.data.userid,
      token: verifyOtpData.data.token,
      password: newPasswordData.password,
      client: "web",
      version: "123"
    };
    if (!Object.keys(errors).length) {
      this.props.newPasswordRequest(data);
    }
  };

  submitUnregisteredEmail = email => {
    const data = {
      name: this.props.signInData.data.data.data.name,
      email: email,
      token: this.state.sendEmail.socialToken,
      signin_mode: this.state.sendEmail.signInMode,
      profilepics: "",
      client: "web"
    };
    this.email = email;
    this.props.addEmailContact(data);
  };

  render() {
    const {
      signIn,
      signUp,
      manualRegistration,
      login,
      resetPassword,
      sendPassword,
      data: { name, email, password },
      errors,
      socialError,
      isRecaptcha,
      otp,
      sendEmail: { openSendEmailModal }
    } = this.state;
    let headerText;
    if (signIn && !manualRegistration) {
      headerText = "Sign-up to never lose your progress";
    } else if (signUp && !login) {
      headerText = "Hi, We are glad to see you back";
    } else if (signIn && manualRegistration) {
      headerText = "Sign-up via Email";
    } else if (signUp && login) {
      headerText = "Sign-in via Email";
    }
    const {
      signUpData,
      signInData,
      passwordInitiateData,
      verifyOtpData,
      setNewPasswordData,
      addEmailContactData
    } = this.props;

    // if (login) {
    //   this.email = this.state.loginData.email;
    //   this.password = this.state.loginData.password;
    // }
    
    
    return (
      <div>
        {/* {process.env.REACT_APP_PROGRAMMING_HUB_API_V1} */}
        <GetUserDetails
          open={openSendEmailModal}
          tagLine={"Need Email"}
          fields={["email"]}
          showLoader={addEmailContactData.isLoading}
          addEmailContactData={addEmailContactData}
          onClose={this.closeSendEmail}
          onSubmit={this.submitUnregisteredEmail}
        />

        <SignOut
          open={this.state.openSignOutModal}
          onClose={this.closeSignOut}
          showCloseBtn
          email={this.email}
          password={this.password}
          fromRegistration
          sendEmail={this.state.sendEmail}
        />
        <Dialog
          onClose={this.handleClose}
          aria-labelledby="customizd-dialog-title"
          open={this.props.open}
          TransitionComponent={Transition}
        >
          <DialogContent
            style={{
              paddingTop: 0,
              width: "100%",
              height: "100%",
              float: "right"
            }}
            className="registration-section"
          >
            {/* loader when any api calls it boats  */}
            {(signUpData.isLoading ||
              signInData.isLoading ||
              passwordInitiateData.isLoading ||
              verifyOtpData.isLoading ||
              setNewPasswordData.isLoading) && (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  background: "rgba(0,0,0,.32)",
                  position: "absolute"
                }}
              >
                {" "}
                <div
                  style={{
                    position: "absolute",
                    top: "29%",
                    left: "16%",
                    zIndex: 10000000
                  }}
                >
                  <RegistrationLoader />
                </div>
              </div>
            )}
            {/* end */}
            {/* back arrow button whenever user wants to go back  */}
            <section id="on-enter" className="content">
              {!resetPassword && (
                <div onClick={() => this.props.modalHandler()}>
                  <a href="javascript:void(0)" className="close-btn">
                    <ModalCloseButton />
                  </a>
                </div>
              )}
              {/* end */}
              {/* hearder text that will change as per user selection on login or sing up */}
              {!resetPassword && (
                <h3 className="h3 light text-white m-b-45">{headerText}</h3>
              )}
              {/* end */}

              {/* will be shown when user will enter otp for reset password */}
              {sendPassword &&
              !(
                verifyOtpData.isSuccess &&
                verifyOtpData.data &&
                verifyOtpData.data.token
              ) ? (
                <section className="update-new-password">
                  <a
                    onClick={this.back}
                    href="javascript:void(0)"
                    className="back-btn"
                  >
                    <ModalBackButton />
                  </a>

                  <h3 className="h3 light text-white m-b-80 m-t-30">
                    Reset Password
                  </h3>
                  {sendPassword && (
                    <h4
                      style={{ marginBottom: "15px", fontSize: "19px" }}
                      className="light text-white m-b-80 m-t-30"
                    >
                      Check your email to enter code
                    </h4>
                  )}

                  <form style={{ marginLeft: "0px" }} className="form m-b-100">
                    <div
                      id="resetPassword"
                      className="form-group m-b-30 d-flex"
                    >
                      <input
                        onChange={this.otpHandler}
                        name="one"
                        type="text"
                        value={otp.one}
                        pattern="\d*"
                        maxLength="1"
                        className="form-control verify m-l-10"
                        ref={this.one}
                      />
                      <input
                        onChange={this.otpHandler}
                        name="two"
                        pattern="\d*"
                        maxLength="1"
                        value={otp.two}
                        type="text"
                        className="form-control verify m-l-10"
                        ref={this.two}
                      />
                      <input
                        onChange={this.otpHandler}
                        name="three"
                        pattern="\d*"
                        maxLength="1"
                        value={otp.three}
                        type="text"
                        className="form-control verify m-l-10"
                        ref={this.three}
                      />
                      <input
                        onChange={this.otpHandler}
                        name="four"
                        pattern="\d*"
                        maxLength="1"
                        value={otp.four}
                        type="text"
                        className="form-control verify m-l-10"
                        ref={this.four}
                      />
                      <input
                        onChange={this.otpHandler}
                        name="five"
                        pattern="\d*"
                        maxLength="1"
                        value={otp.five}
                        type="text"
                        className="form-control verify m-l-10"
                        ref={this.five}
                      />
                      <input
                        onChange={this.otpHandler}
                        name="six"
                        pattern="\d*"
                        maxLength="1"
                        value={otp.six}
                        type="text"
                        className="form-control verify m-l-10"
                        ref={this.six}
                      />
                    </div>
                    <div className="error-message m-l-10">
                      {verifyOtpData.isError &&
                        verifyOtpData.data &&
                        verifyOtpData.data.Reason &&
                        verifyOtpData.data.Reason}
                    </div>
                  </form>
                  <button
                    onClick={e => this.otpVerifyHandler(e)}
                    style={{
                      outline: "none",
                      border: "none",
                      color: "#656981"
                    }}
                    className="btn btn-1 lg link"
                  >
                    Verify
                  </button>
                </section>
              ) : (
                verifyOtpData.isSuccess &&
                verifyOtpData.data &&
                verifyOtpData.data.token && (
                  <section className="reset-password">
                    {/* aboves end */}
                    {/* render when user reset password with his new password */}

                    <h3 className="h3 light text-white m-b-80 m-t-30">
                      Reset Password
                    </h3>

                    <form className="form m-b-100">
                      <div className="form-group m-b-30">
                        <input
                          value={this.state.newPasswordData.password}
                          onChange={this.newPasswordChangedHandler}
                          type="password"
                          name="password"
                          className="form-control"
                          placeholder="Enter new password..."
                        />
                        <div className="error-message">{errors.password}</div>
                      </div>
                    </form>
                    <button
                      style={{
                        color: "#656981",
                        outline: "none",
                        border: "none",
                        cursor: setNewPasswordData.isLoading
                          ? "not-allowed"
                          : "pointer"
                      }}
                      disabled={setNewPasswordData.isLoading}
                      onClick={e => this.updatePassword(e)}
                      className="btn btn-1 lg link"
                    >
                      Update New Password
                    </button>
                  </section>
                )
              )}
              {setNewPasswordData.isSuccess &&
                setNewPasswordData.data &&
                setNewPasswordData.data.Message &&
                setNewPasswordData.data.Message === "SUCCESS" && (
                  <Alert
                    message="Your password reset has been successful"
                    alertType="success"
                  />
                )}
              {/* end */}
              {/* render when user clicks on forgot password button , will ask email */}
              {resetPassword && !sendPassword && (
                <section className="reset-password">
                  <a
                    onClick={this.back}
                    href="javascript:void(0)"
                    className="back-btn"
                  >
                    <ModalBackButton />
                  </a>

                  <h3 className="h3 light text-white m-b-80 m-t-30">
                    Reset Password
                  </h3>

                  <form className="form m-b-100">
                    <div className="form-group m-b-30">
                      <input
                        value={this.state.resetPasswordData.email}
                        onChange={this.resetPasswordEmailHandler}
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                      />
                      <div className="error-message">{errors.email}</div>
                      {passwordInitiateData.isSuccess &&
                        passwordInitiateData.data &&
                        passwordInitiateData.data.Reason && (
                          <Alert
                            message={passwordInitiateData.data.Reason}
                            alertType="error"
                          />
                        )}
                    </div>
                  </form>
                  <button
                    style={{
                      color: "#656981",
                      outline: "none",
                      border: "none",
                      cursor: passwordInitiateData.isLoading
                        ? "not-allowed"
                        : "pointer"
                    }}
                    disabled={passwordInitiateData.isLoading}
                    onClick={e => this.sendPasswordHandler(e)}
                    className="btn btn-1 lg link"
                  >
                    Send Password
                  </button>
                </section>
              )}
              {/* end */}
              {/* render when user login manully with email and password */}
              {login && signUp && !resetPassword ? (
                <form className="form m-b-100">
                  <div className="form-group m-b-20">
                    <input
                      name="email"
                      type="email"
                      value={this.state.loginData.email}
                      className={`form-control ${errors.email ? "error" : ""}`}
                      placeholder="Email"
                      onChange={this.loginChangeHandler}
                    />
                    {errors.email && (
                      <div className="error-message">{errors.email}</div>
                    )}
                  </div>
                  <div className="form-group m-b-30">
                    <input
                      name="password"
                      type="password"
                      value={this.state.loginData.password}
                      className={`form-control ${
                        errors.password ? "error" : ""
                      }`}
                      placeholder="Password"
                      onChange={this.loginChangeHandler}
                    />
                    {errors.password && (
                      <div className="error-message">{errors.password}</div>
                    )}

                    <h5 className="h5 light text-right m-t-15">
                      <a onClick={this.resetPasswordHandler} className="link">
                        Forgot Password?
                      </a>
                    </h5>
                  </div>
                  {isRecaptcha && (
                    <ReCAPTCHA
                      style={{
                        display: "inline-block"
                      }}
                      ref={this._reCaptchaRef}
                      sitekey={TEST_SITE_KEY}
                      onChange={this.handleChange}
                    />
                  )}
                  <a
                    id="wage"
                    onClick={() => this.googleRecaptcha("logIn")}
                    className="btn btn-1 lg link"
                  >
                    Let’s Start Learning
                  </a>
                </form>
              ) : (
                <div className="illustrator-icon m-b-45">
                  {signUp && !login && !resetPassword && <SignUpLottie />}
                </div>
              )}
              {/* end */}
              {/* render when user clicks on register via email button to sing up manually */}
              {manualRegistration && signIn ? (
                <form className="form m-b-100">
                  <div className="form-group m-b-20">
                    <input
                      name="name"
                      value={name}
                      type="text"
                      className={`form-control ${errors.name ? "error" : ""}`}
                      placeholder="Name"
                      onChange={this.onChangeHandler}
                    />
                    {errors.name && (
                      <div className="error-message">{errors.name}</div>
                    )}
                  </div>
                  <div className="form-group m-b-20">
                    <input
                      name="email"
                      value={email}
                      type="email"
                      className={`form-control ${errors.email ? "error" : ""}`}
                      placeholder="Email"
                      onChange={this.onChangeHandler}
                    />
                    {errors.email && (
                      <div className="error-message">{errors.email}</div>
                    )}
                  </div>
                  <div className="form-group m-b-30">
                    <input
                      name="password"
                      value={password}
                      type="password"
                      className={`form-control ${
                        errors.password ? "error" : ""
                      }`}
                      placeholder="Password"
                      onChange={this.onChangeHandler}
                    />
                    {errors.password && (
                      <div className="error-message">{errors.password}</div>
                    )}
                  </div>

                  {/* render recaptcha(bot to avoid boting) when user clicks on button to sign up  */}
                  {isRecaptcha && (
                    <ReCAPTCHA
                      style={{
                        display: "inline-block"
                      }}
                      ref={this._reCaptchaRef}
                      sitekey={TEST_SITE_KEY}
                      onChange={this.handleChange}
                    />
                  )}
                  <a
                    onClick={() => this.googleRecaptcha("singIn")}
                    className="btn btn-1 lg link"
                  >
                    Let’s Start Learning
                  </a>
                </form>
              ) : (
                <div className="illustrator-icon m-b-45">
                  {signIn && !manualRegistration && !resetPassword && (
                    <SignInLottie />
                  )}
                </div>
              )}
              {/* end */}

              {manualRegistration && !resetPassword && (
                <h4 className="h4 light text-white m-t-90">
                  {signIn ? "Other Sign-up options" : "Other Sign-in options"}
                </h4>
              )}
              {!resetPassword && (
                <div style={{ color: "#265156" }}>{socialError}</div>
              )}
              {/* component for facebook login */}
              {!resetPassword && (
                <GoogleLogin
                  clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                  render={renderProps => (
                    <a
                      href="javascript:void(0)"
                      onClick={renderProps.onClick}
                      className="btn m-t-15 btn-5 d-flex align-items-center red"
                    >
                      <span className="icon d-flex align-items-center justify-content-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                        >
                          <g fill="none" fill-rule="nonzero">
                            <path
                              fill="#FBBB00"
                              d="M4.433 12.077l-.696 2.611-2.545.054A10.038 10.038 0 0 1 0 9.982C0 8.314.403 6.743 1.118 5.36l2.266.417.993 2.262a5.997 5.997 0 0 0-.321 1.941c0 .738.133 1.444.377 2.096z"
                            />
                            <path
                              fill="#518EF8"
                              d="M19.825 8.144a10.055 10.055 0 0 1-.044 3.966 10.025 10.025 0 0 1-3.526 5.725l-2.858-.146-.404-2.528a5.973 5.973 0 0 0 2.568-3.05h-5.355V8.143h9.619z"
                            />
                            <path
                              fill="#28B446"
                              d="M16.288 17.791A9.92 9.92 0 0 1 10.036 20c-3.804 0-7.11-2.135-8.798-5.277l3.237-2.661a5.94 5.94 0 0 0 5.561 3.87c1.095 0 2.12-.297 3-.816l3.253 2.675z"
                            />
                            <path
                              fill="#F14336"
                              d="M16.392 2.295l-3.238 2.643a5.92 5.92 0 0 0-3.142-.896 5.944 5.944 0 0 0-5.621 4L1.135 5.382h-.001A9.997 9.997 0 0 1 10.012 0a9.97 9.97 0 0 1 6.38 2.295z"
                            />
                          </g>
                        </svg>
                      </span>
                      <span className="text-red">
                        {signIn ? "Sign-up via Google" : "Sign-in via Google"}
                      </span>
                    </a>
                  )}
                  buttonText="Login"
                  onSuccess={this.googleUser}
                  onFailure={this.googleUser}
                />
              )}
              {/* end */}
              {/* component for facebook login */}
              {!resetPassword && (
                <div id="facebook-custom-button">
                  <FacebookLogin
                    // appId="394216524693126"
                    appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}
                    autoLoad={false}
                    fields="name,email,picture"
                    scope={"public_profile,email"}
                    callback={this.facebookUser}
                    icon={
                      <a
                        href="javascript:void(0)"
                        className="btn m-t-15 btn-5 d-flex align-items-center blue"
                      >
                        <span className="icon d-flex align-items-center justify-content-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="20"
                            viewBox="0 0 12 20"
                          >
                            <path
                              fill="#4F7EC0"
                              fill-rule="nonzero"
                              d="M10.693.004L8.028 0c-2.994 0-4.93 1.932-4.93 4.922v2.27H.42A.414.414 0 0 0 0 7.598v3.289c0 .225.188.407.42.407h2.679v8.297c0 .226.187.408.419.408h3.496c.231 0 .419-.183.419-.408v-8.297h3.133c.231 0 .419-.182.419-.407l.001-3.289a.403.403 0 0 0-.122-.288.425.425 0 0 0-.297-.12H7.433V5.268c0-.925.226-1.394 1.464-1.394l1.795-.001a.413.413 0 0 0 .42-.408V.412a.414.414 0 0 0-.42-.408z"
                            />
                          </svg>
                        </span>
                        <span className="text-blue">
                          {signIn
                            ? "Sign-up via facebook"
                            : "Sign-in via facebook"}
                        </span>
                      </a>
                    }
                  />
                </div>
              )}
              {/* end */}
              {/* different singin and sing up buttons */}

              {manualRegistration || login ? (
                ""
              ) : (
                <a
                  onClick={this.registrationMethod}
                  className="btn m-t-15 btn-5 d-flex align-items-center purple"
                >
                  <span className="icon d-flex align-items-center justify-content-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                    >
                      <g fill="#788DDF" fill-rule="nonzero">
                        <path d="M1.702 4.521c.224.167.9.662 2.029 1.484 1.128.823 1.992 1.457 2.592 1.901l.42.318c.215.164.393.295.535.396.142.1.314.214.515.339.201.125.39.218.569.28.178.063.343.094.495.094h.02a1.5 1.5 0 0 0 .495-.093c.178-.063.367-.157.568-.281.202-.125.373-.238.515-.339.142-.1.32-.232.534-.396l.421-.318c.607-.444 2.15-1.573 4.631-3.385a4.836 4.836 0 0 0 1.207-1.281 2.85 2.85 0 0 0 .485-1.573c0-.459-.156-.851-.47-1.177C16.95.163 16.58 0 16.15 0H1.583C1.075 0 .684.18.411.542.137.902 0 1.354 0 1.896c0 .437.181.911.544 1.422.363.51.75.911 1.158 1.203z" />
                        <path d="M16.744 5.518c-2.164 1.448-3.807 2.573-4.928 3.375-.376.274-.681.488-.916.64-.234.154-.546.31-.935.47-.389.16-.752.24-1.088.24h-.02c-.337 0-.7-.08-1.089-.24-.389-.16-.7-.316-.935-.47-.234-.152-.54-.366-.915-.64-.89-.646-2.53-1.77-4.918-3.375a5.225 5.225 0 0 1-1-.851v7.767c0 .431.155.8.465 1.106.31.307.683.46 1.118.46H16.15c.435 0 .808-.153 1.118-.46.31-.307.465-.675.465-1.106V4.667a5.44 5.44 0 0 1-.99.85z" />
                      </g>
                    </svg>
                  </span>
                  <span className="text-light-blue">
                    {signIn ? "Sign-up via Email" : "Sign-in via Email"}
                  </span>
                </a>
              )}

              {!resetPassword && (
                <h5 className="h5 light text-white m-t-30">
                  {signIn
                    ? "I already have an account."
                    : "I don't have an account."}{" "}
                  <strong>
                    <a onClick={this.registrationHandler} className="link">
                      {signIn ? "Login" : "Sign-up"}
                    </a>
                  </strong>
                </h5>
              )}
            </section>
            {/* end */}
            {signInData.isSuccess && signInData.data.Reason && (
              <Alert
                message={signInData.data.Reason || "Something Went Wrong"}
                alertType="error"
              />
            )}

            {signInData.isError && signInData.data === undefined && (
              <Alert message={"Something Went Wrong"} alertType="error" />
            )}
            {signUpData.isError &&
              signUpData.data.data.Reason === "EMAILIDEXIST" && (
                <Alert
                  message={
                    signUpData.data.data.Message || "Something Went Wrong"
                  }
                  alertType="error"
                />
              )}
            {signUpData.isError &&
              signUpData.data.data.Message === "Invalid Request" && (
                <Alert
                  message={
                    signUpData.data.data.Reason || "Something Went Wrong"
                  }
                  alertType="error"
                />
              )}
            {signUpData.isError && signUpData.data === undefined && (
              <Alert message={"Something Went Wrong"} alertType="error" />
            )}
            {signInData.isError &&
              signInData.data.data &&
              (signInData.data.data.Message === "FAILURE" ||
                signInData.data.data.Message === "UNSUCCESS") && (
                <Alert
                  message={signInData.data.data.Reason}
                  alertType="error"
                />
              )}
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    signUpData: state.signUp,
    signInData: state.signIn,
    passwordInitiateData: state.recoverPasswordInitiate,
    verifyOtpData: state.recoverPasswordVerifyOtp,
    setNewPasswordData: state.setNewPassword,
    addEmailContactData: state.addEmailContact
  };
};
const mapDispatchToProps = dispatch => {
  return {
    signUp: data => dispatch(signUpRequest(data)),
    signIn: data => dispatch(signInRequest(data)),
    passwordInitiateRequest: data =>
      dispatch(recoverPasswordInitiateRequest(data)),
    verifyOtp: data => dispatch(recoverPasswordVerifyOtpRequest(data)),
    newPasswordRequest: data => dispatch(setNewPasswordRequest(data)),
    recoverPasswordInitiateClearData: () =>
      dispatch(recoverPasswordInitiateClearRequest()),
    recoverPasswordVerifyOtpClearData: () =>
      dispatch(recoverPasswordVerifyOtpClearRequest()),
    addEmailContact: data => dispatch(addEmailContactRequest(data))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RegistrationModal)
);
